import React, { useEffect, useState } from "react";
import Item from "examples/Item2/Item";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import colors from "assets/theme/base/colors";
import EmployeeAvatar from "Common/EmployeeAvatar";

function EmployeeNameHeader() {
  const [employee, setEmployee] = useState(null);
  const apiUrl = process.env.REACT_APP_Base_URL;

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const employeeId = localStorage.getItem("personalId");
        if (!employeeId) {
          console.error("Employee ID not found in local storage");
          return;
        }

        const response = await axiosInstance.get(API.employee.employeeGetById(employeeId));
        // response.data is a single object
        setEmployee(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployee();
  }, []);

  if (!employee) {
    return null; // or a loader if you want
  }

  return (
    <div
      className="employee-header-container"
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: colors.primary.main,
        borderRadius: "12px",
        padding: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        position: "relative",
      }}
    >
      <Item
        image={
          <EmployeeAvatar
            name={employee.fullName || `${employee.firstName} ${employee.lastName}`}
            profileImage={employee.profileImage}
            size={55}
            style={{ border: `2px solid ${colors.light.main}` }}
          />
        }
        title={
          <span style={{ color: colors.white.main, fontWeight: 600, fontSize: "1.1rem" }}>
            {employee.fullName || `${employee.firstName} ${employee.lastName}`}
          </span>
        }
        date={
          <span style={{ color: colors.light.main, opacity: 0.9, fontSize: "0.85rem" }}>
            {employee.jobTitleName || employee.designationName}
          </span>
        }
      />
    </div>
  );
}

export default EmployeeNameHeader;